import { createAsyncThunk } from '@reduxjs/toolkit';
import labApi from '../../core/api/lab.api';
import { AliquotLocationsResponse } from '../../core/api/lab.types';

/* Find Sample Batches */
export const aliquotLocationListThunk = createAsyncThunk(
  'batchList/listAliquotLocations',
  async (searchTerm: string, { rejectWithValue }: any) => {
    const response: AliquotLocationsResponse = await labApi.listAliquotLocations(searchTerm);
    if (response.data?.listAliquotLocations) {
      return response.data?.listAliquotLocations;
    }
    return rejectWithValue(response.errors);
  },
);
